var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongoDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 806 806",
    style: {
      enableBackground: "new 0 0 806 806"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#AEDEF3;stroke:#527687;stroke-width:5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 403,
    y1: -158.8911,
    x2: 403,
    y2: 877.0782
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1978,
    style: {
      stopColor: "#FEF9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4559,
    style: {
      stopColor: "#FCE9E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7462,
    style: {
      stopColor: "#F9CECF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9152,
    style: {
      stopColor: "#F6BBBC"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 403,
    cy: 403,
    r: 400
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M509.9,354.1c-25.3-111.5-85-148.2-91.4-162.2c-7-9.9-14.2-27.5-14.2-27.5c-0.1-0.3-0.3-0.8-0.5-1.3 c-0.7,9.9-1.1,13.7-10.4,23.7c-14.5,11.3-88.7,73.6-94.7,200.3C293,505.3,384,575.7,396.3,584.6l1.4,1v-0.1 c0.1,0.6,3.9,28.1,6.6,57.3h9.6c2.3-20.6,5.7-41.1,10.2-61.4l0.8-0.5c5.5-3.9,10.8-8.2,15.7-12.9l0.6-0.5 c26.2-24.2,73.2-80.1,72.7-169.2C513.8,383.6,512.5,368.8,509.9,354.1L509.9,354.1z M403.3,517.9c0,0,0-165.7,5.5-165.7 c4.3,0,9.8,213.8,9.8,213.8C410.9,565.1,403.3,530.8,403.3,517.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDb);
export default __webpack_public_path__ + "static/media/mongoDB.356b456405df06ce6d1970c2974d12ce.svg";
export { ForwardRef as ReactComponent };